import ShiftPageAliasMapping from './ShiftPageAliasMapping';
import BmwPageAliasMapping from './BmwPageAliasMapping';
import KiaPageAliasMapping from './KiaPageAliasMapping';
import LexusPageAliasMapping from './LexusPageAliasMapping';
import MaseratiPageAliasMapping from './MaseratiPageAliasMapping';
import MazdaPageAliasMapping from './MazdaPageAliasMapping';
import PorschePageAliasMapping from './PorschePageAliasMapping';
import ToyotaPageAliasMapping from './ToyotaPageAliasMapping';
import VwPageAliasMapping from './VwPageAliasMapping';

export default {
	ShiftPageAliasMapping,
	BmwPageAliasMapping,
	KiaPageAliasMapping,
	LexusPageAliasMapping,
	MaseratiPageAliasMapping,
	MazdaPageAliasMapping,
	PorschePageAliasMapping,
	ToyotaPageAliasMapping,
	VwPageAliasMapping
};
